import React from "react";
import ReactModal from "react-modal";
import { Formik } from "formik";
import { Col, Form, InputGroup, Button, FormControl } from "react-bootstrap";
import {
    getEquipments,
    saveUpdateEquipments,
    getEquipmentBrand,
} from "../../../api/index";
import { FaPlus } from "react-icons/fa";
import { FaTrash } from "react-icons/fa";
import Loader from "../../loader/loader";
import * as yup from "yup";
import SelectDropDown from "../../shared/drop-down/drop-down";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import "./add-equipment.scss";
import MultipleSelect from "../add-new-application-modal/v2/input-elements/MultiSelect";
import {
    file_type_options,
    package_options,
    cable_length_options,
    connectivity_options,
} from "../../../constants";
import ImageCropper from "../ImageCropper";

const schema = yup.object({
    equipment_name: yup.string().trim().required("* Equiment name is required"),
    equipment_type: yup.string().trim().required("* Equipment is required"),
});

const ems_data = {
    monthly_fee: false,
    monthly_fee_default: "25.00",
    per_transaction: false,
    per_transaction_default: "0.10",
    purchase_for: false,
    purchase_for_default: "230.00",
    rent_for: false,
    rent_for_default: "20.00",
    apply_tpp: false,
    apply_tpp_default: "yes",
    sass_fee: false,
    sass_fee_default: "230.00",
    lease_for: false,
    lease_for_default: "20.00",
    amount: false,
    amount_default: "25.00",
    factor_rate: false,
    factor_rate_default: "0.10",
    payback: false,
    payback_default: "0.10",
    sim_card: false,
    sim_card_monthly_default: "0.05",

    hardware: false,
    hardware_default: "",
    file_types: false,
    file_types_default: "",
    package: false,
    package_default: "",
    other_equipment: false,
    other_equipments_default: "",
    pin_debit: false,
    cable_length: false,
    cable_length_default: "",
    customer_facing: false,
    virtual_terminal: false,
    monthly_wireless: false,
    monthly_wireless_default: "0.10",
    text_sms_fee: false,
    text_sms_fee_default: "0.10",
    promotion_text: "",
    connectivity: false,
    connectivity_options: "",
    connectivity_default: "sim",
    monthly_cellular_txn: false,
    cellular_per_txn: false,
    monthly_cellular_txn_default: "25",
    cellular_per_txn_default: "0.10",
};

class AddEquipmentModal extends React.Component {
    constructor(props) {
        super(props);
        let boot_data = {
            monthly_fee: props.activeEq?.monthly_fee == 1 ? true : false,
            monthly_fee_default: props.activeEq?.monthly_fee_default
                ? props.activeEq?.monthly_fee_default
                : "25.00",
            per_transaction:
                props.activeEq?.per_transaction == 1 ? true : false,
            per_transaction_default: props.activeEq?.per_transaction_default
                ? props.activeEq?.per_transaction_default
                : "0.10",
            purchase_for: props.activeEq?.purchase_for == 1 ? true : false,
            purchase_for_default: props.activeEq?.purchase_for_default
                ? props.activeEq?.purchase_for_default
                : "230.00",
            rent_for: props.activeEq?.rent_for == 1 ? true : false,
            rent_for_default: props.activeEq?.rent_for_default
                ? props.activeEq?.rent_for_default
                : "20.00",
            apply_tpp: props.activeEq?.apply_tpp == 1 ? true : false,
            apply_tpp_default: props.activeEq?.apply_tpp_default
                ? props.activeEq?.apply_tpp_default
                : "yes",
            sass_fee: props.activeEq?.sass_fee == 1 ? true : false,
            sass_fee_default: props.activeEq?.sass_fee_default
                ? props.activeEq?.sass_fee_default
                : "230.00",
            lease_for: props.activeEq?.lease_for == 1 ? true : false,
            lease_for_default: props.activeEq?.lease_for_default
                ? props.activeEq?.lease_for_default
                : "20.00",
            amount: props.activeEq?.amount == 1 ? true : false,
            amount_default: props.activeEq?.amount_default
                ? props.activeEq?.amount_default
                : "25.00",
            factor_rate: props.activeEq?.factor_rate == 1 ? true : false,
            factor_rate_default: props.activeEq?.factor_rate_default
                ? props.activeEq?.factor_rate_default
                : "0.10",
            payback: props.activeEq?.payback == 1 ? true : false,
            payback_default: props.activeEq?.payback_default
                ? props.activeEq?.payback_default
                : "0.10",
            sim_card: props.activeEq?.sim_card == 1 ? true : false,
            sim_card_monthly_default: props.activeEq?.sim_card_monthly_default
                ? props.activeEq?.sim_card_monthly_default
                : "0.05",

            hardware: props.activeEq?.hardware == 1 ? true : false,
            hardware_default:
                props.activeEq?.hardware_default != null
                    ? props.activeEq?.hardware_default
                    : "",
            file_types: props.activeEq?.file_types == 1 ? true : false,
            file_types_default:
                props.activeEq?.file_types_default != null
                    ? props.activeEq?.file_types_default
                    : "",
            package: props.activeEq?.package == 1 ? true : false,
            package_default:
                props.activeEq?.package_default != null
                    ? props.activeEq?.package_default
                    : "",
            other_equipments: props.activeEq?.package == 1 ? true : false,
            other_equipments_default:
                props.activeEq?.other_equipments_default != null
                    ? props.activeEq?.other_equipments_default
                    : "",
            customer_facing:
                props.activeEq?.customer_facing == 1 ? true : false,

            pin_pad: props.activeEq?.pin_pad == 1 ? true : false,
            pin_pad_name_default: props.activeEq?.pin_pad_name_default ?? "",
            monthly_wireless:
                props.activeEq?.monthly_wireless == 1 ? true : false,
            monthly_wireless_default: props.activeEq?.monthly_wireless_default
                ? props.activeEq?.monthly_wireless_default
                : "0.10",
            virtual_terminal:
                props.activeEq?.virtual_terminal == 1 ? true : false,
            text_sms_fee: props.activeEq?.text_sms_fee == 1 ? true : false,
            text_sms_fee_default: props.activeEq?.text_sms_fee_default
                ? props.activeEq?.text_sms_fee_default
                : "0.10",
            pin_debit: props.activeEq?.pin_debit == "1" ? true : false,
            cable_length: props.activeEq?.cable_length == "1" ? true : false,
            cable_length_default: props.activeEq?.cable_length_default || "",
            promotion_text: props.activeEq?.promotion_text || "",

            connectivity: props.activeEq?.connectivity == 1 ? true : false,
            connectivity_default: props.activeEq?.connectivity_default || "",
            connectivity_options: props.activeEq?.connectivity_options || "",

            monthly_cellular_txn:
                props.activeEq?.monthly_cellular_txn == 1 ? true : false,
            cellular_per_txn:
                props.activeEq?.cellular_per_txn == 1 ? true : false,
            monthly_cellular_txn_default:
                props.activeEq?.monthly_cellular_txn_default != null
                    ? props.activeEq?.monthly_cellular_txn_default
                    : ems_data.monthly_cellular_txn_default,
            cellular_per_txn_default:
                props.activeEq?.cellular_per_txn_default != null
                    ? props.activeEq?.cellular_per_txn_default
                    : ems_data.cellular_per_txn_default,

            add_on_equipment:
                props.activeEq?.add_on_equipment == 1 ? true : false,
            add_on_equipment_options:
                props.activeEq?.add_on_equipment_options?.join(",") ?? "",

            equipment_for_nuvie: props.activeEq?.equipment_for_nuvie == 1 ?
                true : false,
            nuvie_equipment_name: props.activeEq?.nuvie_equipment_name || "",
        };
        this.state = {
            isEdit: props.isEdit,
            show_spinner: false,
            errorMessage: "",
            formData: {
                equipment_name: "",
                equipment_type: "terminal",
                equipment_image: null,
                equipment_pdf: null,
                description: "",
                free_text: "",
                is_ems_boot: "no",
                category:
                    this.props.activeEq?.category_id !== undefined
                        ? this.props.activeEq?.category_id
                        : "",
                brand_id: this.props.activeEq?.brand_id
                    ? this.props.activeEq?.brand_id
                    : "",
            },
            errors: [],
            equipments: [],
            activeEq: props.activeEq,
            fieldList: [],
            pointsValue: {},
            image_to_show: null,
            ems_boot_data: props.activeEq ? boot_data : ems_data,
            categories: {
                terminals: [],
                gateways: [],
                add_ons: [],
                add_ons_options: [],
            },
            equipmentOptions: {},
            imageCropDialogOpen: false,
            uploadedImage: [],
            equipmentBrands: [],
        };
    }

    componentDidMount() {
        getEquipments()
            .then((res) => {
                const result = res.data.equipments.reduce((acc, current) => {
                    acc[current.id] = current.equipment_name;
                    return acc;
                }, {});
                this.setState({ equipmentOptions: result });
            })
            .catch((err) => {
                console.log(err);
            });

        if (this.props.isEdit) {
            let array = Object.entries(
                JSON.parse(this.state.activeEq.feature_points),
            );
            let field_list_array = [];
            array.splice(0, 1);
            array.forEach((item, index) => {
                field_list_array.push({ name: item[0] });
            });
            this.setState({
                formData: {
                    ...this.state.formData,
                    equipment_name: this.state.activeEq.equipment_name,
                    equipment_type: this.state.activeEq.equipment_type,
                    description:
                        this.state.activeEq.description == "null"
                            ? ""
                            : this.state.activeEq.description,
                    free_text:
                        this.state.activeEq.free_text == "null"
                            ? ""
                            : this.state.activeEq.free_text,
                    is_ems_boot:
                        this.state.activeEq.is_ems_boot == 0 ? "no" : "yes",
                    category: this.state.activeEq.category_id,
                },
                fieldList: field_list_array,
                pointsValue: JSON.parse(this.state.activeEq.feature_points),
            });
        }
        if (this.props.categories.length > 0) {
            let cats_terminals = this.props.categories
                .filter((cat) => cat.category_type == "terminal")
                .map((cat) => ({ label: cat.category, value: cat.id }));
            let cats_gateways = this.props.categories
                .filter((cat) => cat.category_type == "gateway")
                .map((cat) => ({ label: cat.category, value: cat.id }));
            let add_on_cats = this.props.categories
                .filter((cat) => cat.category_type == "add_on")
                .map((cat) => ({ label: cat.category, value: cat.id }));

            let add_ons_options = [
                { label: "Terminals", options: cats_terminals },
                { label: "Gateways", options: cats_gateways },
                { label: "Add Ons", options: add_on_cats },
            ];

            this.setState({
                categories: {
                    terminals: cats_terminals.length > 0 ? cats_terminals : [],
                    gateways: cats_gateways.length > 0 ? cats_gateways : [],
                    add_ons: add_on_cats,
                    add_ons_options: add_ons_options,
                },
            });
        }

        getEquipmentBrand({ all: "all" })
            .then((res) => {
                if (res.status && res.data.length > 0) {
                    let equipment_brands = res.data.map((brand) => ({
                        label: brand.name,
                        value: brand.id,
                    }));
                    this.setState({ equipmentBrands: equipment_brands });
                }
            })
            .catch((err) => {});
    }

    handleAddEquipment = (e) => {
        this.setState({ show_spinner: true });
        const formData = new FormData();
        if (this.state.formData.equipment_image !== null) {
            formData.append(
                "equipment_image",
                this.state.formData.equipment_image,
                this.state.formData.equipment_image.name,
            );
        }
        if (this.state.formData.equipment_pdf !== null) {
            formData.append(
                "equipment_pdf",
                this.state.formData.equipment_pdf,
                this.state.formData.equipment_pdf.name,
            );
        }

        formData.append("equipment_name", this.state.formData.equipment_name);
        formData.append("equipment_type", this.state.formData.equipment_type);
        formData.append("description", this.state.formData.description);
        formData.append("free_text", this.state.formData.free_text);
        formData.append("is_ems_boot", this.state.formData.is_ems_boot);
        formData.append("category", this.state.formData.category);
        formData.append("brand_id", this.state.formData.brand_id);
        formData.append(
            "feature_points",
            JSON.stringify(this.state.pointsValue),
        );
        formData.append(
            "ems_boot_data",
            JSON.stringify(this.state.ems_boot_data),
        );
        if (this.props.isEdit) {
            formData.append("id", this.state.activeEq.id);
        }

        saveUpdateEquipments(formData)
            .then((res) => {
                if (res.status) {
                    this.props.handleCloseModel();
                    this.props.refreshList(this.props.page);
                } else {
                    this.setState({
                        errorMessage: res.message,
                    });
                }
                this.setState({ show_spinner: false });
            })
            .catch((err) => {
            });
    };

    updateChange(evt) {
        const targetName = evt.target.name;
        if (targetName === "") {
            return false;
        }
        let formData = this.state.formData;
        if (
            targetName === "equipment_image" ||
            targetName === "equipment_pdf"
        ) {
            formData[targetName] = evt.target.files[0];
        } else {
            formData[targetName] = evt.target.value.trim();
        }
        this.setState({ formData: formData, errorMessage: "" });
    }

    handlePointChange = (e) => {
        this.setState({
            pointsValue: {
                ...this.state.pointsValue,
                [e.target.name]: e.target.value,
            },
        });
    };

    removePoint = (index, field_name) => {
        let fieldList = this.state.fieldList;
        fieldList.splice(index, 1);
        this.setState({
            fieldList: fieldList,
        });

        let points_value = this.state.pointsValue;
        delete points_value[field_name];

        this.setState({
            pointsValue: points_value,
        });
    };

    setShowImage(event) {
        this.setState({
            image_to_show: URL.createObjectURL(event.target.files[0]),
        });
    }

    handleImageCrop = (e) => {
        this.setState({
            imageCropDialogOpen: true,
            uploadedImage: URL.createObjectURL(e.target.files[0]),
        });
    };

    handleEmsBootDataChange(event) {
        let value = "";
        if (event.target.type == "checkbox") {
            value = event.target.checked;
        } else {
            value = event.target.value;
        }
        this.setState({
            ems_boot_data: {
                ...this.state.ems_boot_data,
                [event.target.name]: value,
            },
        });
    }

    handleMultiSelect = (value, name) => {
        this.setState({
            ems_boot_data: {
                ...this.state.ems_boot_data,
                [name]: value,
            },
        });
    };

    categoryDropOptions = (values) => {
        if (values.equipment_type == "terminal")
            return this.state.categories.terminals;
        if (values.equipment_type == "gateway")
            return this.state.categories.gateways;
        if (values.equipment_type == "add_on")
            return this.state.categories.add_ons_options;
    };

    handleConnectivityChange(e) {
        this.setState({
            ems_boot_data: {
                ...this.state.ems_boot_data,
                connectivity_default: e.target.value,
            },
        });
    }

    render() {
        const {
            isEdit,
            show_spinner,
            errorMessage,
            formData,
            errors,
            is_submitted,
            pointsValue,
            ems_boot_data,
            equipmentOptions,
        } = this.state;
        const pointsVal = Object.entries(pointsValue);
        return (
            <ReactModal
                isOpen={this.props.show}
                className="add-template-modal equipment-modal"
            >
                <div className="modal-header">
                    <h4 className="text-left">
                        {isEdit ? "Edit Equipment" : "Add Equipment"}
                    </h4>
                </div>
                <div
                    onClick={() => this.props.handleCloseModel()}
                    className="modal-cancel"
                >
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-body">
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(e) => this.handleAddEquipment(e)}
                        initialValues={formData}
                        initialErrors={errors}
                        validateOnBlur={false}
                        validateOnChange={is_submitted}
                        validate={(values) => {
                            this.setState({ is_submitted: true });
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            touched,
                            errors,
                        }) => (
                            <Form
                                id="add-template-form"
                                onSubmit={handleSubmit}
                                onChange={(e) => this.updateChange(e)}
                                autoComplete="off"
                            >
                                <Form.Row>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Control
                                            placeholder="Equipment Name"
                                            type="text"
                                            name="equipment_name"
                                            value={
                                                values.equipment_name
                                                    ? values.equipment_name
                                                    : ""
                                            }
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.equipment_name &&
                                                !!errors.equipment_name
                                            }
                                            isValid={
                                                is_submitted &&
                                                !errors.equipment_name
                                            }
                                            className="preapp-form-input"
                                        />
                                        <label className="modal-lab">
                                            Equipment Name
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.equipment_name}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <div className="pri-heading1 mg-bottom-15">
                                            Select Equipment Type
                                        </div>
                                        <div className="d-flex tire-new">
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="equipment_type"
                                                    value="terminal"
                                                    checked={
                                                        values.equipment_type ===
                                                        "terminal"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    Terminal
                                                </span>
                                            </label>
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="equipment_type"
                                                    value="gateway"
                                                    checked={
                                                        values.equipment_type ===
                                                        "gateway"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    Gateway
                                                </span>
                                            </label>
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="equipment_type"
                                                    value="add_on"
                                                    checked={
                                                        values.equipment_type ===
                                                        "add_on"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    Add On
                                                </span>
                                            </label>
                                        </div>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.equipment_type}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <div className="row">
                                        <div className="col-md-9 col-sm-9">
                                            <Form.Group
                                                as={Col}
                                                xs={12}
                                                className="px-3"
                                            >
                                                <Form.Control
                                                    placeholder="Equipment Image"
                                                    type="file"
                                                    name="equipment_image"
                                                    value={undefined}
                                                    onChange={(e) => {
                                                        this.handleImageCrop(e);
                                                    }}
                                                    isInvalid={
                                                        touched.equipment_image &&
                                                        !!errors.equipment_image
                                                    }
                                                    isValid={
                                                        is_submitted &&
                                                        !errors.equipment_image
                                                    }
                                                    className="preapp-form-input w-100"
                                                />
                                                <label className="modal-lab">
                                                    Equipment Image
                                                </label>
                                                <Form.Control.Feedback
                                                    type="invalid"
                                                    className="text-capitalize"
                                                >
                                                    {" "}
                                                    {
                                                        errors.equipment_image
                                                    }{" "}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className="col-md-3 col-sm-3">
                                            {this.state.activeEq !== null &&
                                                this.state.image_to_show ==
                                                    null && (
                                                    <img
                                                        src={
                                                            "img-equipment/" +
                                                            this.state.activeEq
                                                                .id
                                                        }
                                                        style={{
                                                            width: "100px",
                                                            height: "100px",
                                                            border: "1px solid #cecece",
                                                            borderRadius: "50%",
                                                            marginTop: "-75%",
                                                        }}
                                                    />
                                                )}
                                            {this.state.image_to_show !==
                                                null && (
                                                <img
                                                    src={
                                                        this.state.image_to_show
                                                    }
                                                    style={{
                                                        width: "100px",
                                                        height: "100px",
                                                        border: "1px solid #cecece",
                                                        borderRadius: "50%",
                                                        marginTop: "-75%",
                                                    }}
                                                />
                                            )}
                                        </div>
                                        <ImageCropper
                                            open={
                                                this.state.imageCropDialogOpen
                                            }
                                            image={this.state.uploadedImage}
                                            onComplete={(imagePromise) => {
                                                imagePromise.then((image) => {
                                                    fetch(image)
                                                        .then((response) =>
                                                            response.blob(),
                                                        ) // Convert the response to a Blob
                                                        .then((blob) => {
                                                            this.setState({
                                                                formData: {
                                                                    ...this
                                                                        .state
                                                                        .formData,
                                                                    equipment_image:
                                                                        blob,
                                                                },
                                                                image_to_show:
                                                                    image,
                                                                imageCropDialogOpen: false,
                                                            });
                                                        });
                                                });
                                            }}
                                            containerStyle={{
                                                position: "relative",
                                                width: "100%",
                                                height: 300,
                                                background: "#333",
                                            }}
                                        />
                                    </div>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Control
                                            placeholder="Equipment PDF"
                                            type="file"
                                            name="equipment_pdf"
                                            value={
                                                values.equipment_pdf
                                                    ? values.equipment_pdf
                                                    : ""
                                            }
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.equipment_pdf &&
                                                !!errors.equipment_pdf
                                            }
                                            isValid={
                                                is_submitted &&
                                                !errors.equipment_pdf
                                            }
                                            className="preapp-form-input w-100"
                                        />
                                        <label className="modal-lab">
                                            Equipment PDF
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.equipment_pdf}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3 mb-10"
                                    >
                                        <Form.Label>Feature points</Form.Label>
                                        <InputGroup className="mb-3">
                                            <FormControl
                                                placeholder="Feature points"
                                                type={"text"}
                                                value={pointsValue.point_1}
                                                name="point_1"
                                                onChange={
                                                    this.handlePointChange
                                                }
                                            />
                                            <InputGroup.Append>
                                                <Button
                                                    variant="success"
                                                    onClick={() => {
                                                        this.setState({
                                                            fieldList: [
                                                                ...this.state
                                                                    .fieldList,
                                                                {
                                                                    name:
                                                                        "point_" +
                                                                        (this
                                                                            .state
                                                                            .fieldList
                                                                            .length +
                                                                            2),
                                                                },
                                                            ],
                                                        });
                                                    }}
                                                >
                                                    <FaPlus />
                                                </Button>
                                            </InputGroup.Append>
                                        </InputGroup>
                                    </Form.Group>

                                    {this.state.fieldList.map(
                                        (element, index) => (
                                            <Form.Group
                                                as={Col}
                                                xs={12}
                                                className="px-3 mb-10"
                                            >
                                                <InputGroup className="mb-3">
                                                    <FormControl
                                                        placeholder="Feature points"
                                                        type={"text"}
                                                        name={element.name}
                                                        value={
                                                            pointsValue[
                                                                element.name
                                                            ]
                                                        }
                                                        onChange={
                                                            this
                                                                .handlePointChange
                                                        }
                                                    />
                                                    <InputGroup.Append>
                                                        <Button
                                                            variant="danger"
                                                            onClick={() =>
                                                                this.removePoint(
                                                                    index,
                                                                    element.name,
                                                                )
                                                            }
                                                        >
                                                            <FaTrash />
                                                        </Button>
                                                    </InputGroup.Append>
                                                </InputGroup>
                                            </Form.Group>
                                        ),
                                    )}

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <label className="modal-lab">
                                            Is EMS Boot
                                        </label>
                                        <div className="row">
                                            <div className="col-md-2 col-sm-2 col-xs-3">
                                                <Form.Check
                                                    inline
                                                    label="Yes"
                                                    value={"yes"}
                                                    checked={
                                                        values.is_ems_boot ==
                                                        "yes"
                                                    }
                                                    name="is_ems_boot"
                                                    type="radio"
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="col-md-2 col-sm-2 col-xs-3">
                                                <Form.Check
                                                    inline
                                                    label="No"
                                                    value="no"
                                                    name="is_ems_boot"
                                                    checked={
                                                        values.is_ems_boot ==
                                                        "no"
                                                    }
                                                    type="radio"
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.description}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    {values.is_ems_boot == "yes" && (
                                        <div className="ems-boot-options mb-4">
                                            <div className="row">
                                                <div className="col-6 col-md-6 col-sm-6">
                                                    <div className="row">
                                                        <div className="col-5 col-md-5 col-sm-5">
                                                            <label htmlFor="monthly_fee">
                                                                Monthly Fee
                                                            </label>
                                                            <br />
                                                            <Toggle
                                                                id="monthly_fee"
                                                                checked={
                                                                    ems_boot_data.monthly_fee
                                                                }
                                                                name="monthly_fee"
                                                                onChange={(e) =>
                                                                    this.handleEmsBootDataChange(
                                                                        e,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-7 col-md-7 col-sm-7">
                                                            <Form.Group controlId="purchase_for">
                                                                <Form.Label>
                                                                    Monthly Fee
                                                                    Default
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    placeholder="225"
                                                                    name="monthly_fee_default"
                                                                    value={
                                                                        ems_boot_data.monthly_fee_default
                                                                    }
                                                                    className="text-center"
                                                                    disabled={
                                                                        !ems_boot_data.monthly_fee
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                />
                                                                <span className="fc-symbol">
                                                                    $
                                                                </span>
                                                            </Form.Group>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-6 col-md-6 col-sm-6">
                                                    <div className="row">
                                                        <div className="col-5 col-md-5 col-sm-5">
                                                            <label htmlFor="per_transaction">
                                                                Per Transaction
                                                            </label>
                                                            <br />
                                                            <Toggle
                                                                id="per_transaction"
                                                                checked={
                                                                    ems_boot_data.per_transaction
                                                                }
                                                                name="per_transaction"
                                                                onChange={(e) =>
                                                                    this.handleEmsBootDataChange(
                                                                        e,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-7 col-md-7 col-sm-7">
                                                            <Form.Group controlId="per_transaction_default">
                                                                <Form.Label>
                                                                    Per
                                                                    Transaction
                                                                    Default
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    placeholder="225"
                                                                    name="per_transaction_default"
                                                                    value={
                                                                        ems_boot_data.per_transaction_default
                                                                    }
                                                                    disabled={
                                                                        !ems_boot_data.per_transaction
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                    className="text-center"
                                                                />
                                                                <span className="fc-symbol">
                                                                    $
                                                                </span>
                                                            </Form.Group>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-6 col-md-6 col-sm-6">
                                                    <div className="row">
                                                        <div className="col-5 col-md-5 col-sm-5">
                                                            <label htmlFor="purchase_for">
                                                                Purchase For
                                                            </label>
                                                            <br />
                                                            <Toggle
                                                                id="purchase_for"
                                                                checked={
                                                                    ems_boot_data.purchase_for
                                                                }
                                                                name="purchase_for"
                                                                onChange={(e) =>
                                                                    this.handleEmsBootDataChange(
                                                                        e,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-7 col-md-7 col-sm-7">
                                                            <Form.Group controlId="purchase_for">
                                                                <Form.Label>
                                                                    Purchase For
                                                                    Default
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    placeholder="225"
                                                                    name="purchase_for_default"
                                                                    value={
                                                                        ems_boot_data.purchase_for_default
                                                                    }
                                                                    disabled={
                                                                        !ems_boot_data.purchase_for
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                    className="text-center"
                                                                />
                                                                <span className="fc-symbol">
                                                                    $
                                                                </span>
                                                            </Form.Group>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-6 col-md-6 col-sm-6">
                                                    <div className="row">
                                                        <div className="col-5 col-md-5 col-sm-5">
                                                            <label htmlFor="rent_for">
                                                                Rent For
                                                            </label>
                                                            <br />
                                                            <Toggle
                                                                id="rent_for"
                                                                checked={
                                                                    ems_boot_data.rent_for
                                                                }
                                                                name="rent_for"
                                                                onChange={(e) =>
                                                                    this.handleEmsBootDataChange(
                                                                        e,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-7 col-md-7 col-sm-7">
                                                            <Form.Group controlId="purchase_for">
                                                                <Form.Label>
                                                                    Rent For
                                                                    Default
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    placeholder="225"
                                                                    name="rent_for_default"
                                                                    value={
                                                                        ems_boot_data.rent_for_default
                                                                    }
                                                                    disabled={
                                                                        !ems_boot_data.rent_for
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                    className="text-center"
                                                                />
                                                                <span className="fc-symbol">
                                                                    $
                                                                </span>
                                                            </Form.Group>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-6 col-md-6 col-sm-6">
                                                    <div className="row">
                                                        <div className="col-5 col-md-5 col-sm-5">
                                                            <label htmlFor="monthly_wireless">
                                                                Monthly Wireless
                                                            </label>
                                                            <br />
                                                            <Toggle
                                                                id="monthly_wireless"
                                                                checked={
                                                                    ems_boot_data.monthly_wireless
                                                                }
                                                                name="monthly_wireless"
                                                                onChange={(e) =>
                                                                    this.handleEmsBootDataChange(
                                                                        e,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-7 col-md-7 col-sm-7">
                                                            <Form.Group controlId="monthly_wireless_default">
                                                                <Form.Label>
                                                                    Monthly
                                                                    Wireless
                                                                    Default
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    placeholder="225"
                                                                    name="monthly_wireless_default"
                                                                    value={
                                                                        ems_boot_data.monthly_wireless_default
                                                                    }
                                                                    disabled={
                                                                        !ems_boot_data.monthly_wireless
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                    className="text-center"
                                                                />
                                                                <span className="fc-symbol">
                                                                    $
                                                                </span>
                                                            </Form.Group>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-6 col-md-6 col-sm-6">
                                                    <div className="row">
                                                        <div className="col-5 col-md-5 col-sm-5">
                                                            <label htmlFor="sass_fee">
                                                                SaaS Fee
                                                            </label>
                                                            <br />
                                                            <Toggle
                                                                id="sass_fee"
                                                                checked={
                                                                    ems_boot_data.sass_fee
                                                                }
                                                                name="sass_fee"
                                                                onChange={(e) =>
                                                                    this.handleEmsBootDataChange(
                                                                        e,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-7 col-md-7 col-sm-7">
                                                            <Form.Group controlId="sass_fee_default">
                                                                <Form.Label>
                                                                    SaaS Fee
                                                                    Default
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    placeholder="225"
                                                                    name="sass_fee_default"
                                                                    value={
                                                                        ems_boot_data.sass_fee_default
                                                                    }
                                                                    disabled={
                                                                        !ems_boot_data.sass_fee
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                    className="text-center"
                                                                />
                                                                <span className="fc-symbol">
                                                                    $
                                                                </span>
                                                            </Form.Group>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-6 col-md-6 col-sm-6">
                                                    <div className="row">
                                                        <div className="col-5 col-md-5 col-sm-5">
                                                            <label htmlFor="lease_for">
                                                                Lease For
                                                            </label>
                                                            <br />
                                                            <Toggle
                                                                id="lease_for"
                                                                checked={
                                                                    ems_boot_data.lease_for
                                                                }
                                                                name="lease_for"
                                                                onChange={(e) =>
                                                                    this.handleEmsBootDataChange(
                                                                        e,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-7 col-md-7 col-sm-7">
                                                            <Form.Group controlId="lease_for_default">
                                                                <Form.Label>
                                                                    Lease For
                                                                    Default
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    placeholder="225"
                                                                    name="lease_for_default"
                                                                    value={
                                                                        ems_boot_data.lease_for_default
                                                                    }
                                                                    disabled={
                                                                        !ems_boot_data.lease_for
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                    className="text-center"
                                                                />
                                                                <span className="fc-symbol">
                                                                    $
                                                                </span>
                                                            </Form.Group>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-6 col-md-6 col-sm-6">
                                                    <div className="row">
                                                        <div className="col-5 col-md-5 col-sm-5">
                                                            <label htmlFor="amount">
                                                                Amount
                                                            </label>
                                                            <br />
                                                            <Toggle
                                                                id="amount"
                                                                checked={
                                                                    ems_boot_data.amount
                                                                }
                                                                name="amount"
                                                                onChange={(e) =>
                                                                    this.handleEmsBootDataChange(
                                                                        e,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-7 col-md-7 col-sm-7">
                                                            <Form.Group controlId="amount_default">
                                                                <Form.Label>
                                                                    Amount
                                                                    Default
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    placeholder="225"
                                                                    name="amount_default"
                                                                    value={
                                                                        ems_boot_data.amount_default
                                                                    }
                                                                    disabled={
                                                                        !ems_boot_data.amount
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                    className="text-center"
                                                                />
                                                                <span className="fc-symbol">
                                                                    $
                                                                </span>
                                                            </Form.Group>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-6 col-md-6 col-sm-6">
                                                    <div className="row">
                                                        <div className="col-5 col-md-5 col-sm-5">
                                                            <label htmlFor="factor_rate">
                                                                Factor Rate
                                                            </label>
                                                            <br />
                                                            <Toggle
                                                                id="factor_rate"
                                                                checked={
                                                                    ems_boot_data.factor_rate
                                                                }
                                                                name="factor_rate"
                                                                onChange={(e) =>
                                                                    this.handleEmsBootDataChange(
                                                                        e,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-7 col-md-7 col-sm-7">
                                                            <Form.Group controlId="factor_rate_default">
                                                                <Form.Label>
                                                                    Factor Rate
                                                                    Default
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    placeholder="225"
                                                                    name="factor_rate_default"
                                                                    value={
                                                                        ems_boot_data.factor_rate_default
                                                                    }
                                                                    disabled={
                                                                        !ems_boot_data.factor_rate
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                    className="text-center"
                                                                />
                                                                <span className="fc-symbol">
                                                                    %
                                                                </span>
                                                            </Form.Group>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-6 col-md-6 col-sm-6">
                                                    <div className="row">
                                                        <div className="col-5 col-md-5 col-sm-5">
                                                            <label htmlFor="payback">
                                                                Payback
                                                            </label>
                                                            <br />
                                                            <Toggle
                                                                id="payback"
                                                                checked={
                                                                    ems_boot_data.payback
                                                                }
                                                                name="payback"
                                                                onChange={(e) =>
                                                                    this.handleEmsBootDataChange(
                                                                        e,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-7 col-md-7 col-sm-7">
                                                            <Form.Group controlId="payback_default">
                                                                <Form.Label>
                                                                    Payback
                                                                    Default
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    placeholder="225"
                                                                    name="payback_default"
                                                                    value={
                                                                        ems_boot_data.payback_default
                                                                    }
                                                                    disabled={
                                                                        !ems_boot_data.payback
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                    className="text-center"
                                                                />
                                                                <span className="fc-symbol">
                                                                    $
                                                                </span>
                                                            </Form.Group>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-6 col-md-6 col-sm-6">
                                                    <div className="row">
                                                        <div className="col-5 col-md-5 col-sm-5">
                                                            <label htmlFor="sim_card">
                                                                SIM Card
                                                            </label>
                                                            <br />
                                                            <Toggle
                                                                id="sim_card"
                                                                checked={
                                                                    ems_boot_data.sim_card
                                                                }
                                                                name="sim_card"
                                                                onChange={(e) =>
                                                                    this.handleEmsBootDataChange(
                                                                        e,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-7 col-md-7 col-sm-7">
                                                            <Form.Group controlId="sim_card_monthly_default">
                                                                <Form.Label>
                                                                    Monthly
                                                                    Wireless
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    placeholder="0.05"
                                                                    name="sim_card_monthly_default"
                                                                    value={
                                                                        ems_boot_data.sim_card_monthly_default
                                                                    }
                                                                    disabled={
                                                                        !ems_boot_data.sim_card
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                    className="text-center"
                                                                />
                                                                <span className="fc-symbol">
                                                                    $
                                                                </span>
                                                            </Form.Group>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-12 col-sm-12">
                                                    <div className="col-6 col-md-6 col-sm-6">
                                                        <div className="row">
                                                            <div className="col-4 col-md-4 col-sm-4">
                                                                <label htmlFor="hardware">
                                                                    Hardware
                                                                </label>
                                                                <br />
                                                                <Toggle
                                                                    id="hardware"
                                                                    checked={
                                                                        ems_boot_data.hardware
                                                                    }
                                                                    name="hardware"
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-8 col-md-8 col-sm-8">
                                                                <Form.Group controlId="hardware_default">
                                                                    <Form.Label>
                                                                        Hardware
                                                                        Default
                                                                    </Form.Label>
                                                                    <MultipleSelect
                                                                        options={
                                                                            equipmentOptions
                                                                        }
                                                                        onChange={
                                                                            this
                                                                                .handleMultiSelect
                                                                        }
                                                                        selectedKeys={
                                                                            ems_boot_data.hardware_default ==
                                                                                "" ||
                                                                            ems_boot_data.hardware_default ==
                                                                                null
                                                                                ? []
                                                                                : ems_boot_data.hardware_default.split(
                                                                                      ",",
                                                                                  )
                                                                        }
                                                                        name="hardware_default"
                                                                        disabled={
                                                                            !ems_boot_data.hardware
                                                                        }
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-6 col-md-6 col-sm-6">
                                                        <div className="row">
                                                            <div className="col-4 col-md-4 col-sm-4">
                                                                <label htmlFor="file_types">
                                                                    File Types
                                                                </label>
                                                                <br />
                                                                <Toggle
                                                                    id="file_types"
                                                                    checked={
                                                                        ems_boot_data.file_types
                                                                    }
                                                                    name="file_types"
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-8 col-md-8 col-sm-8">
                                                                <Form.Group controlId="file_types_default">
                                                                    <Form.Label>
                                                                        File
                                                                        Types
                                                                        Default
                                                                    </Form.Label>
                                                                    <MultipleSelect
                                                                        options={
                                                                            file_type_options
                                                                        }
                                                                        onChange={
                                                                            this
                                                                                .handleMultiSelect
                                                                        }
                                                                        selectedKeys={
                                                                            ems_boot_data.file_types_default ==
                                                                                "" ||
                                                                            ems_boot_data.file_types_default ==
                                                                                null
                                                                                ? []
                                                                                : ems_boot_data.file_types_default.split(
                                                                                      ",",
                                                                                  )
                                                                        }
                                                                        name="file_types_default"
                                                                        disabled={
                                                                            !ems_boot_data.file_types
                                                                        }
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-12 col-sm-12 ems-boot-options-row">
                                                    <div className="col-6 col-md-6 col-sm-6">
                                                        <div className="row">
                                                            <div className="col-4 col-md-4 col-sm-4">
                                                                <label htmlFor="package">
                                                                    Package
                                                                </label>
                                                                <br />
                                                                <Toggle
                                                                    id="package"
                                                                    checked={
                                                                        ems_boot_data.package
                                                                    }
                                                                    name="package"
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-8 col-md-8 col-sm-8">
                                                                <Form.Group controlId="package_default">
                                                                    <Form.Label>
                                                                        Package
                                                                        Default
                                                                    </Form.Label>
                                                                    <MultipleSelect
                                                                        options={
                                                                            package_options
                                                                        }
                                                                        onChange={
                                                                            this
                                                                                .handleMultiSelect
                                                                        }
                                                                        selectedKeys={
                                                                            ems_boot_data.package_default ==
                                                                                "" ||
                                                                            ems_boot_data.package_default ==
                                                                                null
                                                                                ? []
                                                                                : ems_boot_data.package_default.split(
                                                                                      ",",
                                                                                  )
                                                                        }
                                                                        name="package_default"
                                                                        disabled={
                                                                            !ems_boot_data.package
                                                                        }
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-6 col-md-6 col-sm-6">
                                                        <div className="row">
                                                            <div className="col-4 col-md-4 col-sm-4">
                                                                <label htmlFor="payback">
                                                                    Other
                                                                    Equipments
                                                                </label>
                                                                <br />
                                                                <Toggle
                                                                    id="other_equipments"
                                                                    checked={
                                                                        ems_boot_data.other_equipments
                                                                    }
                                                                    name="other_equipments"
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-8 col-md-8 col-sm-8">
                                                                <Form.Group controlId="other_equipments_default">
                                                                    <Form.Label>
                                                                        Other
                                                                        Equipments
                                                                        Default
                                                                    </Form.Label>
                                                                    <MultipleSelect
                                                                        options={
                                                                            equipmentOptions
                                                                        }
                                                                        onChange={
                                                                            this
                                                                                .handleMultiSelect
                                                                        }
                                                                        selectedKeys={
                                                                            ems_boot_data.other_equipments_default ==
                                                                                "" ||
                                                                            ems_boot_data.other_equipments_default ==
                                                                                null
                                                                                ? []
                                                                                : ems_boot_data.other_equipments_default.split(
                                                                                      ",",
                                                                                  )
                                                                        }
                                                                        name="other_equipments_default"
                                                                        disabled={
                                                                            !ems_boot_data.other_equipments
                                                                        }
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-12 col-sm-12 ems-boot-options-row">
                                                    <div className="col-6 col-md-6 col-sm-6">
                                                        <div className="row">
                                                            <div className="col-5 col-md-5 col-sm-5">
                                                                <label htmlFor="text_sms_fee">
                                                                    Text/SMS Fee
                                                                </label>
                                                                <br />
                                                                <Toggle
                                                                    id="text_sms_fee"
                                                                    checked={
                                                                        ems_boot_data.text_sms_fee
                                                                    }
                                                                    name="text_sms_fee"
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-7 col-md-7 col-sm-7">
                                                                <Form.Group controlId="text_sms_fee_default">
                                                                    <Form.Label>
                                                                        Text/SMS
                                                                        Fee
                                                                        Default
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        type="number"
                                                                        placeholder="225"
                                                                        name="text_sms_fee_default"
                                                                        value={
                                                                            ems_boot_data.text_sms_fee_default
                                                                        }
                                                                        disabled={
                                                                            !ems_boot_data.text_sms_fee
                                                                        }
                                                                        onChange={(
                                                                            e,
                                                                        ) =>
                                                                            this.handleEmsBootDataChange(
                                                                                e,
                                                                            )
                                                                        }
                                                                        className="text-center"
                                                                    />
                                                                    <span className="fc-symbol">
                                                                        $
                                                                    </span>
                                                                </Form.Group>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-6 col-md-6 col-sm-6">
                                                        <div className="row">
                                                            <div className="col-5 col-md-5 col-sm-5">
                                                                <label htmlFor="cable_length">
                                                                    Length
                                                                </label>
                                                                <br />
                                                                <Toggle
                                                                    id="cable_length"
                                                                    checked={
                                                                        ems_boot_data.cable_length
                                                                    }
                                                                    name="cable_length"
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-7 col-md-7 col-sm-7">
                                                                <Form.Group controlId="cable_length_default">
                                                                    <Form.Label>
                                                                        Cable
                                                                        Length
                                                                        Default
                                                                    </Form.Label>
                                                                    <MultipleSelect
                                                                        options={
                                                                            cable_length_options
                                                                        }
                                                                        onChange={
                                                                            this
                                                                                .handleMultiSelect
                                                                        }
                                                                        selectedKeys={
                                                                            ems_boot_data.cable_length_default ==
                                                                                "" ||
                                                                            ems_boot_data.cable_length_default ==
                                                                                null
                                                                                ? []
                                                                                : ems_boot_data.cable_length_default.split(
                                                                                      ",",
                                                                                  )
                                                                        }
                                                                        name="cable_length_default"
                                                                        disabled={
                                                                            !ems_boot_data.other_equipments
                                                                        }
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-8 col-md-8 col-sm-8">
                                                        <div className="row">
                                                            <div className="col-4 col-md-4 col-sm-4">
                                                                <label htmlFor="connectivity">
                                                                    Connectivity
                                                                </label>
                                                                <br />
                                                                <Toggle
                                                                    id="connectivity"
                                                                    checked={
                                                                        ems_boot_data.connectivity
                                                                    }
                                                                    name="connectivity"
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-8 col-md-8 col-sm-8">
                                                                <Form.Group controlId="connectivity_options">
                                                                    <Form.Label>
                                                                        Connectivity
                                                                        Options
                                                                    </Form.Label>
                                                                    <MultipleSelect
                                                                        options={
                                                                            connectivity_options
                                                                        }
                                                                        onChange={
                                                                            this
                                                                                .handleMultiSelect
                                                                        }
                                                                        selectedKeys={
                                                                            ems_boot_data.connectivity_options ==
                                                                                "" ||
                                                                            ems_boot_data.connectivity_options ==
                                                                                null
                                                                                ? []
                                                                                : ems_boot_data.connectivity_options.split(
                                                                                      ",",
                                                                                  )
                                                                        }
                                                                        name="connectivity_options"
                                                                        disabled={
                                                                            !ems_boot_data.connectivity
                                                                        }
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-4 col-md-4 col-sm-4">
                                                        <div className="row">
                                                            <div className="col-12 col-md-12 col-sm-12">
                                                                <Form.Group controlId="exampleForm.ControlSelect1">
                                                                    <Form.Label
                                                                        style={{
                                                                            marginBottom:
                                                                                "14px",
                                                                        }}
                                                                    >
                                                                        Connectivity
                                                                        Default
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        as="select"
                                                                        name="connectivity_default"
                                                                        value={
                                                                            ems_boot_data.connectivity_default
                                                                        }
                                                                        onChange={(
                                                                            e,
                                                                        ) =>
                                                                            this.handleConnectivityChange(
                                                                                e,
                                                                            )
                                                                        }
                                                                    >
                                                                        <option value=""></option>
                                                                        {Object.entries(
                                                                            connectivity_options,
                                                                        ).map(
                                                                            ([
                                                                                key,
                                                                                value,
                                                                            ]) => (
                                                                                <option
                                                                                    value={
                                                                                        key
                                                                                    }
                                                                                >
                                                                                    {
                                                                                        value
                                                                                    }
                                                                                </option>
                                                                            ),
                                                                        )}
                                                                    </Form.Control>
                                                                </Form.Group>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {ems_boot_data.connectivity && (
                                                        <>
                                                            <div className="col-6 col-md-6 col-sm-6 mt-2">
                                                                <div className="row">
                                                                    <div className="col-5 col-md-5 col-sm-5">
                                                                        <label htmlFor="monthly_cellular_txn">
                                                                            Monthly
                                                                            Cellular
                                                                            Txn
                                                                        </label>
                                                                        <br />
                                                                        <Toggle
                                                                            id="monthly_cellular_txn"
                                                                            checked={
                                                                                ems_boot_data.monthly_cellular_txn
                                                                            }
                                                                            name="monthly_cellular_txn"
                                                                            onChange={(
                                                                                e,
                                                                            ) =>
                                                                                this.handleEmsBootDataChange(
                                                                                    e,
                                                                                )
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-7 col-md-7 col-sm-7">
                                                                        <Form.Group controlId="monthly_cellular_txn">
                                                                            <Form.Label>
                                                                                Monthly
                                                                                Cellular
                                                                                Txn
                                                                                Default
                                                                            </Form.Label>
                                                                            <Form.Control
                                                                                type="number"
                                                                                placeholder="25"
                                                                                name="monthly_cellular_txn_default"
                                                                                value={
                                                                                    ems_boot_data.monthly_cellular_txn_default
                                                                                }
                                                                                disabled={
                                                                                    !ems_boot_data.monthly_cellular_txn
                                                                                }
                                                                                onChange={(
                                                                                    e,
                                                                                ) =>
                                                                                    this.handleEmsBootDataChange(
                                                                                        e,
                                                                                    )
                                                                                }
                                                                                className="text-center"
                                                                            />
                                                                            <span className="fc-symbol">
                                                                                $
                                                                            </span>
                                                                        </Form.Group>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-6 col-md-6 col-sm-6 mt-2">
                                                                <div className="row">
                                                                    <div className="col-5 col-md-5 col-sm-5">
                                                                        <label htmlFor="cellular_per_txn">
                                                                            Cellular/Txn
                                                                        </label>
                                                                        <br />
                                                                        <Toggle
                                                                            id="cellular_per_txn"
                                                                            checked={
                                                                                ems_boot_data.cellular_per_txn
                                                                            }
                                                                            name="cellular_per_txn"
                                                                            onChange={(
                                                                                e,
                                                                            ) =>
                                                                                this.handleEmsBootDataChange(
                                                                                    e,
                                                                                )
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="col-7 col-md-7 col-sm-7">
                                                                        <Form.Group controlId="purchase_for">
                                                                            <Form.Label>
                                                                                Cellular/Txn
                                                                                Default
                                                                            </Form.Label>
                                                                            <Form.Control
                                                                                type="number"
                                                                                placeholder="0.10"
                                                                                name="cellular_per_txn_default"
                                                                                value={
                                                                                    ems_boot_data.cellular_per_txn_default
                                                                                }
                                                                                disabled={
                                                                                    !ems_boot_data.cellular_per_txn
                                                                                }
                                                                                onChange={(
                                                                                    e,
                                                                                ) =>
                                                                                    this.handleEmsBootDataChange(
                                                                                        e,
                                                                                    )
                                                                                }
                                                                                className="text-center"
                                                                            />
                                                                            <span className="fc-symbol">
                                                                                $
                                                                            </span>
                                                                        </Form.Group>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>

                                                <div className="col-6 col-md-6 col-sm-6">
                                                    <div className="row">
                                                        <div className="col-6 col-md-6 col-sm-6">
                                                            <label htmlFor="customer_facing">
                                                                Customer Facing
                                                            </label>
                                                            <br />
                                                            <Toggle
                                                                id="customer_facing"
                                                                checked={
                                                                    ems_boot_data.customer_facing
                                                                }
                                                                name="customer_facing"
                                                                onChange={(e) =>
                                                                    this.handleEmsBootDataChange(
                                                                        e,
                                                                    )
                                                                }
                                                            />
                                                        </div>

                                                        <div className="col-6 col-md-6 col-sm-6">
                                                            <label htmlFor="apply_tpp">
                                                                Apply TPP
                                                            </label>
                                                            <br />
                                                            <Toggle
                                                                id="apply_tpp"
                                                                checked={
                                                                    ems_boot_data.apply_tpp
                                                                }
                                                                name="apply_tpp"
                                                                onChange={(e) =>
                                                                    this.handleEmsBootDataChange(
                                                                        e,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-6 col-md-6 col-sm-6">
                                                    <div className="row">
                                                        <div className="col-6 col-md-6 col-sm-6">
                                                            <label htmlFor="virtual_terminal">
                                                                Virtual Terminal
                                                            </label>
                                                            <br />
                                                            <Toggle
                                                                id="virtual_terminal"
                                                                checked={
                                                                    ems_boot_data.virtual_terminal
                                                                }
                                                                name="virtual_terminal"
                                                                onChange={(e) =>
                                                                    this.handleEmsBootDataChange(
                                                                        e,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-6 col-md-6 col-sm-6">
                                                            <label htmlFor="virtual_terminal">
                                                                PIN Debit
                                                            </label>
                                                            <br />
                                                            <Toggle
                                                                id="pin_debit"
                                                                checked={
                                                                    ems_boot_data.pin_debit
                                                                }
                                                                name="pin_debit"
                                                                onChange={(e) =>
                                                                    this.handleEmsBootDataChange(
                                                                        e,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-12 col-sm-12 ems-boot-options-row">
                                                    <div className="row">
                                                        <div className="col-2 col-md-2 col-sm-2">
                                                            <label htmlFor="pin_pad">
                                                                Pin Pad
                                                            </label>
                                                            <br />
                                                            <Toggle
                                                                id="pin_pad"
                                                                checked={
                                                                    ems_boot_data.pin_pad
                                                                }
                                                                name="pin_pad"
                                                                onChange={(e) =>
                                                                    this.handleEmsBootDataChange(
                                                                        e,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-4 col-md-4 col-sm-4">
                                                            <Form.Group controlId="pin_pad_name_default">
                                                                <Form.Label>
                                                                    Pin Pad Name
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Name of Pin Pad"
                                                                    isInvalid={
                                                                        errors?.pin_pad_name_default
                                                                    }
                                                                    disabled={
                                                                        !ems_boot_data?.pin_pad
                                                                    }
                                                                    name="pin_pad_name_default"
                                                                    value={
                                                                        ems_boot_data.pin_pad_name_default
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                    className="text-center"
                                                                />
                                                            </Form.Group>
                                                        </div>

                                                        <div className="col-2 col-md-2 col-sm-2">
                                                            <label htmlFor="add_on_equipment">
                                                                Add On Eqpmnts.
                                                            </label>
                                                            <br />
                                                            <Toggle
                                                                id="add_on_equipment"
                                                                checked={
                                                                    ems_boot_data.add_on_equipment
                                                                }
                                                                name="add_on_equipment"
                                                                onChange={(e) =>
                                                                    this.handleEmsBootDataChange(
                                                                        e,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-4 col-md-4 col-sm-4">
                                                            <Form.Group controlId="connectivity_options">
                                                                <Form.Label>
                                                                    Addon
                                                                    Options
                                                                </Form.Label>
                                                                <MultipleSelect
                                                                    options={
                                                                        equipmentOptions
                                                                    }
                                                                    onChange={
                                                                        this
                                                                            .handleMultiSelect
                                                                    }
                                                                    selectedKeys={
                                                                        ems_boot_data.add_on_equipment_options ==
                                                                            "" ||
                                                                        ems_boot_data.add_on_equipment_options ==
                                                                            null
                                                                            ? []
                                                                            : ems_boot_data.add_on_equipment_options.split(
                                                                                  ",",
                                                                              )
                                                                    }
                                                                    name="add_on_equipment_options"
                                                                    disabled={
                                                                        !ems_boot_data.add_on_equipment
                                                                    }
                                                                />
                                                            </Form.Group>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-12 col-sm-12">
                                                    <div className="row">
                                                        <div className="col-6 col-md-6 col-sm-6">
                                                            <Form.Group controlId="text_sms_fee_default">
                                                                <Form.Label>
                                                                    Promotion
                                                                    Text
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Most Popular"
                                                                    name="promotion_text"
                                                                    value={
                                                                        ems_boot_data.promotion_text
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                    className="text-center"
                                                                />
                                                            </Form.Group>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-6 col-md-6 col-sm-6">
                                                    <div className="row">
                                                        <div className="col-4 col-md-4 col-sm-4">
                                                            <label htmlFor="equipment_for_nuvie">
                                                                Nuvie
                                                            </label>
                                                            <br />
                                                            <Toggle
                                                                id="equipment_for_nuvie"
                                                                checked={
                                                                    ems_boot_data.equipment_for_nuvie
                                                                }
                                                                name="equipment_for_nuvie"
                                                                onChange={(
                                                                    e,
                                                                ) =>
                                                                    this.handleEmsBootDataChange(
                                                                        e,
                                                                    )
                                                                }
                                                            />
                                                        </div>

                                                        <div className="col-8 col-md-8 col-sm-8">
                                                            <Form.Group controlId="nuvie_name">
                                                                <Form.Label>
                                                                    Nuvie Name
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    isInvalid={
                                                                        errors?.nuvie_equipment_name
                                                                    }
                                                                    disabled={
                                                                        !ems_boot_data?.equipment_for_nuvie
                                                                    }
                                                                    name="nuvie_equipment_name"
                                                                    value={
                                                                        ems_boot_data.nuvie_equipment_name
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.handleEmsBootDataChange(
                                                                            e,
                                                                        )
                                                                    }
                                                                    className="text-center"
                                                                />
                                                            </Form.Group>
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    )}

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <label className="modal-lab">
                                            Category
                                        </label>
                                        <SelectDropDown
                                            options={this.categoryDropOptions(
                                                values,
                                            )}
                                            handleChange={(e) => {
                                                this.setState({
                                                    formData: {
                                                        ...this.state.formData,
                                                        category: e.value,
                                                    },
                                                });
                                            }}
                                            value={values.category}
                                            name="category"
                                            groupedOptions={
                                                values.equipment_type ==
                                                "add_on"
                                                    ? true
                                                    : false
                                            }
                                        />
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <label className="modal-lab">
                                            Brand
                                        </label>
                                        <SelectDropDown
                                            options={this.state.equipmentBrands}
                                            handleChange={(e) => {
                                                this.setState({
                                                    formData: {
                                                        ...this.state.formData,
                                                        brand_id: e.value,
                                                    },
                                                });
                                            }}
                                            value={values.brand_id}
                                            name="brand_id"
                                            groupedOptions={
                                                values.equipment_type ==
                                                "add_on"
                                                    ? true
                                                    : false
                                            }
                                        />
                                    </Form.Group>




                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <label className="modal-lab">
                                            Description
                                        </label>
                                        <textarea
                                            className="form-control"
                                            name="description"
                                            value={
                                                values.description
                                                    ? values.description
                                                    : ""
                                            }
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.description &&
                                                !!errors.description
                                            }
                                            isValid={
                                                is_submitted &&
                                                !errors.description
                                            }
                                            rows="5"
                                            //className="preapp-form-input"
                                        ></textarea>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.description}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <label className="modal-lab">
                                            Free Text
                                        </label>
                                        <textarea
                                            className="form-control"
                                            name="free_text"
                                            value={
                                                values.free_text
                                                    ? values.free_text
                                                    : ""
                                            }
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.free_text &&
                                                !!errors.free_text
                                            }
                                            isValid={
                                                is_submitted &&
                                                !errors.free_text
                                            }
                                            //className="preapp-form-input"
                                            rows="5"
                                        ></textarea>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.free_text}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        )}
                    </Formik>
                </div>
                {show_spinner ? (
                    <div className="spinner">
                        <Loader />
                    </div>
                ) : (
                    ""
                )}
                <p className="error-message text-center">{errorMessage}</p>
                <div className="modal-footer">
                    <div className="button-twoc">
                        <button
                            form="add-template-form"
                            type="submit"
                            disabled={show_spinner}
                            className="btn confirm-button"
                        >
                            {" "}
                            {isEdit ? "Update" : "Add"}{" "}
                        </button>
                        <button
                            className="btn cancel-button"
                            onClick={() => this.props.handleCloseModel()}
                        >
                            {" "}
                            Cancel{" "}
                        </button>
                    </div>
                </div>
            </ReactModal>
        );
    }
}

export default AddEquipmentModal;
